import React from "react";
import { Grid } from "material-ui";

export const GridDivider = () => {
    return (
        <Grid container>
            <Grid item xs={12}>
                <hr
                    color={"#BDBCBC"}
                    style={{
                        marginTop: 15,
                        marginBottom: 15,
                        height: "1px",
                        borderStyle: "none",
                    }}
                ></hr>
            </Grid>
        </Grid>
    );
};



// WEBPACK FOOTER //
// ./src/components/GridDivider/GridDivider.tsx